module.exports = require("././angular-deferred-bootstrap.js");


/*****************
 ** WEBPACK FOOTER
 ** angular-deferred-bootstrap (bower component)
 ** module id = 369
 ** module chunks = 1
 **/